import "./App.css";
import React from "react";
import Header from "./components/header/header";
import Hero from "./components/hero/hero";
import About from "./components/about/about";
import Menu from "./components/menu/menu";
import Reservation from "./components/reservation/reservation";
import Testimonials from "./components/testimonials/testimonial";
import Footer from "./components/footer/footer";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      {/* <About /> */}
      <Menu />
      {/* <Reservation /> */}
      <Testimonials />
      <Footer />
    </div>
  );
}

export default App;
